import React, { useEffect, useState } from 'react';
import { MdPublic, MdContentCopy, MdOpenInNew, MdWarningAmber } from 'react-icons/md';
import API from '../api';
import { useLanguage } from '../i18n';

// Admin-only card (shown on the Spaces page): the public link visitors use to
// see this organization's facilities and book spaces. Organizations created by
// sign-up have their own database, so their public pages need their code in the
// link (?system=...); the original system uses the plain address.
export default function PublicLinkCard({ availableSpaces }) {
    const { t } = useLanguage();
    const [info, setInfo] = useState(null);
    const [copied, setCopied] = useState('');

    useEffect(() => {
        API.get('/signup/join-code').then(({ data }) => setInfo(data)).catch(() => setInfo({ system_code: null }));
    }, []);

    if (!info) return null;

    const code = info.system_code ? encodeURIComponent(info.system_code) : '';
    const links = [
        { key: 'booking', label: t('publicLink.home'), url: code ? `${window.location.origin}/o/${code}` : `${window.location.origin}/` },
        { key: 'report', label: t('publicLink.report'), url: code ? `${window.location.origin}/o/${code}/report` : `${window.location.origin}/report` },
    ];
    const copy = async (key, text) => {
        try { await navigator.clipboard.writeText(text); setCopied(key); setTimeout(() => setCopied(''), 1800); } catch (e) { /* clipboard blocked */ }
    };

    return (
        <div className="page-card" style={{ padding: 18, marginBottom: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <MdPublic style={{ color: '#0b5ed7' }} />
                <h6 style={{ margin: 0, fontWeight: 700 }}>{t('publicLink.title')}</h6>
            </div>
            <p style={{ margin: '0 0 12px', color: '#64748b', fontSize: 13 }}>{t('publicLink.description')}</p>
            {availableSpaces === 0 && (
                <div className="alert alert-warning py-2" style={{ fontSize: 13, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <MdWarningAmber style={{ marginTop: 2, flexShrink: 0 }} /> <span>{t('publicLink.noAvailable')}</span>
                </div>
            )}
            {links.map(link => (
                <div key={link.key} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                    <div style={{ minWidth: 150, fontSize: 13, fontWeight: 600 }}>{link.label}</div>
                    <code style={{ background: '#f1f5f9', borderRadius: 8, padding: '6px 10px', fontSize: 13, wordBreak: 'break-all', flex: '1 1 260px' }}>{link.url}</code>
                    <button className="btn btn-outline-primary btn-sm" onClick={() => copy(link.key, link.url)}>
                        <MdContentCopy /> {copied === link.key ? t('publicLink.copied') : t('publicLink.copy')}
                    </button>
                    <a className="btn btn-outline-secondary btn-sm" href={link.url} target="_blank" rel="noopener noreferrer">
                        <MdOpenInNew /> {t('publicLink.open')}
                    </a>
                </div>
            ))}
            <p style={{ margin: '8px 0 0', color: '#94a3b8', fontSize: 12 }}>{t('publicLink.loggedInNote')}</p>
        </div>
    );
}
